/**
 * @typedef {{ chargeType: string, label: string, required: boolean }} CrossDockPurchaseOrderAdditionalFeeTypeOption
 */

/**
 * @param {CrossDockPurchaseOrderAdditionalFeeTypeOption[]} chargeTypes
 * @returns {string|null}
 */
export function getRequiredAdditionalFeeChargeType(chargeTypes) {
    const match = (chargeTypes ?? []).find((type) => type.required === true);
    return match?.chargeType ?? null;
}

/**
 * @param {CrossDockPurchaseOrderAdditionalFeeTypeOption[]} chargeTypes
 * @returns {CrossDockPurchaseOrderAdditionalFeeTypeOption[]}
 */
export function getOptionalAdditionalFeeTypeOptions(chargeTypes) {
    return (chargeTypes ?? []).filter((type) => type.required !== true);
}

/**
 * @param {CrossDockPurchaseOrderAdditionalFeeTypeOption[]} chargeTypes
 * @param {string} chargeType
 * @returns {string}
 */
export function getAdditionalFeeChargeTypeLabel(chargeTypes, chargeType) {
    const match = (chargeTypes ?? []).find((type) => type.chargeType === chargeType);
    return match?.label ?? chargeType;
}

/**
 * @param {CrossDockPurchaseOrderAdditionalFeeTypeOption[]} chargeTypes
 * @param {string} [fallback='Service Fee']
 * @returns {string}
 */
export function getRequiredAdditionalFeeLabel(chargeTypes, fallback = 'Service Fee') {
    const requiredChargeType = getRequiredAdditionalFeeChargeType(chargeTypes);
    if (!requiredChargeType) {
        return fallback;
    }
    return getAdditionalFeeChargeTypeLabel(chargeTypes, requiredChargeType);
}
